import {createStrokeSVG} from './TEMPLATE'

// tabler: help-circle
export const CircleQuestion_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0',
    'M12 16v.01',
    'M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
